const TRUE_VALUES = new Set([true, 1, '1', 'true']);
const FALSE_VALUES = new Set([false, 0, '0', 'false']);

export function hasFlyproPreference(booking) {
  const noPreferences = booking?.no_preferences;

  if (TRUE_VALUES.has(noPreferences)) return false;
  if (FALSE_VALUES.has(noPreferences)) return true;

  return false;
}

export function getFlyproDisplayName(therapist) {
  const fullName = therapist?.extra?.full_name?.trim();
  if (fullName) return fullName;

  const fallbackName = [therapist?.firstname, therapist?.lastname]
    .filter(Boolean)
    .join(' ')
    .trim();

  return fallbackName || '-';
}
